import { http, pagination } from 'utils'
import {
  SET_ITEMS,
  ADD_ITEMS,
  SET_META
} from 'vx/mutations'
import { concat } from 'lodash'

export default {
  namespaced: true,

  state: {
    requestProducts: [],
    meta: null
  },

  actions: {
    async getRequestProducts ({ commit, state }, { requestId, params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta)) {
          return Promise.reject(new Error('No more results.'))
        }

        params.page = state.meta.current_page + 1
      }

      const response = await http.get(`replenishment-requests/${requestId}/products`, { params })

      commit(SET_ITEMS, response.data)

      return response
    },

    async updateRequestProducts ({ commit }, { requestId }) {
      const response = await http.get(`replenishment-requests/${requestId}/products/update`)

      return response
    },

    resetRequestProducts ({ commit }) {
      commit(SET_ITEMS, [])
      commit(SET_META, null)
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.requestProducts = items
    },

    [ADD_ITEMS] (state, items) {
      state.requestProducts = concat(state.requestProducts, items)
    },

    [SET_META] (state, meta) {
      state.meta = meta
    }
  }
}
